// import { useState } from 'react';
import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";
import MatchUp from "./matchup";
// import { GenderType } from '../../models/index';
import matchupGridStyles from "./matchupgrid.module.css";
function MatchupGrid() {
  // const [gender, setGender] = useState(GenderType.FEMALE);
  // const { genderContainer } = matchupGridStyles;

  const GET_SESSIONS = gql`
    query ListSessions {
      listSessions(filter: { access: { eq: PUBLIC } }) {
        items {
          id
          sessionKey
          startAt
          status
          name
        }
      }
    }
  `;

  const { loading, error, data } = useQuery(GET_SESSIONS);

  const matches = data?.listSessions?.items || [];

  // Group matches by day and sort within each day
  const groupMatchesByDay = (matches) => {
    // Create an object to group matches by date string
    const groupedByDay = matches.reduce((acc, match) => {
      const date = new Date(match.startAt);
      const dateString = date.toLocaleDateString();

      if (!acc[dateString]) {
        acc[dateString] = [];
      }
      acc[dateString].push(match);
      return acc;
    }, {});

    // Convert to array of arrays and sort matches within each day
    return Object.values(groupedByDay).map((dayMatches) =>
      dayMatches.sort((a, b) => new Date(a.startAt) - new Date(b.startAt))
    );
  };

  const matchesByDay = groupMatchesByDay(matches);

  if (loading)
    return (
      <div className={matchupGridStyles.container}>
        <div className={matchupGridStyles.loading}>
          <div className={matchupGridStyles.spinner}></div>
        </div>
      </div>
    );

  if (error) return null;

  return (
    <div className="heroGrid">
      {/* <ul>
        {matches.map((match, i) => (
          <li key={match.id}>
            <MatchUp match={match} />
          </li>
        ))}
      </ul>
      
      */}
      <ul>
        {matchesByDay.map((dayMatches, i) => {
          if (dayMatches.length === 0) return null;

          // Get date string for the first match of the day
          const dateString = new Date(
            dayMatches[0].startAt
          ).toLocaleDateString();

          return (
            <li key={i}>
              <h5>{dateString}</h5>
              {dayMatches.map((match, j) => (
                <MatchUp match={match} key={j} />
              ))}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default MatchupGrid;
